import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

const DialogBox = ({ currentText, setModalForText }) => {
  // Close modal on pressing 'Escape' key
  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === 'Escape') {
        setModalForText(false);
      }
    };

    window.addEventListener('keydown', handleEscapeKey);
    return () => {
      window.removeEventListener('keydown', handleEscapeKey);
    };
  }, [setModalForText]);

  const handleOutsideClick = (event) => {
    if (event.target === event.currentTarget) {
      setModalForText(false);
    }
  };

  return (
    <div style={modalStyle} onClick={handleOutsideClick}>
      <div style={modalContentStyle}>
        <div style={textContainerStyle}>{currentText}</div>
        <button
          className="btn btn-warning"
          style={buttonStyle}
          onClick={() => setModalForText(false)} // Handle the cancel action
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

DialogBox.propTypes = {
  currentText: PropTypes.node.isRequired, // Accepts any node
  setModalForText: PropTypes.func.isRequired,
};

export default DialogBox;

// Styles for the modal
const modalStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "rgba(0, 0, 0, 0.7)", // Darker background for better contrast
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 1000,
  padding: '10px', // Add padding for mobile responsiveness
};

const modalContentStyle = {
  backgroundColor: "#fff", // White background for the modal
  padding: "20px",
  borderRadius: "8px",
  width: "100%", // Make width 100% to ensure it adapts to all screens
  maxWidth: "500px", // Max width for larger screens
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)", // Add a shadow for depth
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  height: "auto", // Auto height to fit content
  maxHeight: "80vh", // Max height to keep modal within the viewport
  boxSizing: 'border-box', // Ensure padding doesn't affect width
  overflowY: "auto", // Make content scrollable if it overflows
};

const textContainerStyle = {
  flexGrow: 1,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "flex-start",
  marginBottom: "10px", // Space between text and button
  fontSize: "1rem", // Responsive font size
  wordWrap: "break-word", // Ensure long text breaks into new lines
};

const buttonStyle = {
  alignSelf: "center", // Center the button horizontally
  padding: "10px 20px", // Add padding to the button
  cursor: "pointer", // Change cursor to pointer
  fontSize: "1rem", // Responsive font size for button text
  width: "100%", // Full width on smaller screens
  maxWidth: "150px", // Restrict button width on larger screens
};

